import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionPropertyBase from "./ModelActionPropertyBase";

export default class Model extends ModelActionPropertyBase {

    type = new PropertyDescriptor('default', '刷新目标', "高级", "enum", "#anticon-icon-test", {
        description: "选择一种需要刷新的数据源。若选择“指定数据源”，您还需要输入一个数据源名称",
        values: [
            new PropertyDescriptor("default", "默认数据源", "", "string", ""),
            new PropertyDescriptor("byname", "指定数据源", "", "string", ""),
        ],
    });

    target = new PropertyDescriptor("", '数据源名称', "高级", "string", "#anticon-ui-text-field-format", {
        description: "需要刷新的数据源的名称",
        visible: false,
    });

    script = new PropertyDescriptor(``, '使用 Javascript 创建刷新参数', "高级", "js", "#anticon-Documentation", {
        description: '使用脚本的返回值作为刷新数据源的参数',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
        this.resetVisible();
    }

    resetVisible() {
        this.setPropertyVisible("target", this.type !== "default");
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {

        // console.log(name, valNew);

        if (name === "type") {
            this.resetVisible();
        }
    }

    run(data, opts) {
        const model = opts.model;
        let ds = null;

        if (this.type === "default")
            ds = model.getDefaultDataSource();
        else {
            ds = model.getDataSource(this.target && this.target.trim());
        }

        if (!ds)
            return;

        if (this.script)
            data = opts.runScript(this.script, data, undefined, undefined, { throwException: true });

        ds && ds.refresh(data);
    }

    toString() {
        return this.type === "default" ? "默认" : this.target;
    }
}
